import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AuthManagerService} from 'src/app/auth/auth-manager.service';
import {Observable} from "rxjs/internal/Observable";
import { LanguagePickerService } from '../../language-picker/language-picker.service';
import {debounceTime, map, switchMap} from "rxjs/operators";
import {OrderItem} from "../../../model/order/order";
import {OrdersApiService} from "../../../api/orders-api.service";
import {MessageService} from "../../message/message.service";
import {NewOrderStoreService} from "../../../new-order/new-order-store-service.service";
import {CartService} from "../../cart/cart.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {of} from "rxjs/index";
import {ChangeAccountService} from "../../change-account.service";
import {LoginData, User} from "../../../auth/auth.model";

@Component({
  selector: 'app-nav-user',
  templateUrl: './nav-user.component.html',
  styleUrls: ['./nav-user.component.scss']
})
export class NavUserComponent implements OnInit {

  @Output() showLogin = new EventEmitter();

  readonly isAdmin$: Observable<boolean>;

  isGroupAccount: boolean;
  searchForm: FormGroup;
  searchResult =[];
  accounts = [];
  currentUser: User;

  constructor(
    private router: Router,
    private authManagerService: AuthManagerService,
    private languagePickerService: LanguagePickerService,
    private cartService: CartService,
    private newOrderStoreService: NewOrderStoreService,
    private ordersApiService: OrdersApiService,
    private messages: MessageService,
    private formBuilder: FormBuilder,
    private changeAccountService: ChangeAccountService
  ) {
    this.isAdmin$ = this.authManagerService.isAdmin$;
    this.currentUser = this.authManagerService.currentUser;
    this.changeAccountService.isGroupAccount().subscribe(value => this.isGroupAccount = value);

    window.onbeforeunload = (event) => {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        this.saveAndGoToHome();
      }
    };
  }

  ngOnInit(): void {
    this.changeAccountService.accounts.filter(line =>  {
      this.accounts.push(line.customerNumber);
    });
    this.searchForm = this.formBuilder.group({
      searchBar : ''
    });
    this.onChanges();
  }

  onChanges() {
    this.searchForm.get('searchBar').valueChanges.pipe(
      debounceTime(500),
      switchMap(  (customerNumber: string) => {
        return customerNumber ? this.changeAccountService.searchingValue(customerNumber.replace(/[\s]/g,'')) : of([]);
      })
    ).subscribe(data =>{
      this.searchResult = data as Array<{}>;
    })
  }

  changeAccount() {
    this.changeAccountService.getAccounts().forEach(account => {
      if (account.customerNumber == this.searchForm.controls['searchBar'].value) {
        let loginData: LoginData = {
          'customerNumber': account.customerNumber,
          'username': '',
          'password': ''
        };
        this.authManagerService.change(loginData, account.customerName).subscribe(response => {
          if (response.success) {
            this.currentUser = this.authManagerService.currentUser;
            window.location.reload();
            this.messages.info('home.login.success');
          } else {
            this.messages.errorCode('home.login.fail');
          }
        });
      }
    });
  }

  goToHome() {
    this.newOrderStoreService.setCopyTrialLensRight(undefined);
    this.newOrderStoreService.setCopyTrialLensLeft(undefined);

    let orderItems: OrderItem[] = [];
    this.cartService.getCartItems().subscribe(data => orderItems = data);
    let hasUpdates = orderItems.some(orderItem => orderItem.isNew === true || orderItem.isUpdate === true);
    if (hasUpdates){
      this.saveCartAndLeave();
    } else {
      this.router.navigate(['/']);
    }
  }

  goToAdmin() {
    this.router.navigate(['/admin']);
  }

  goToOrders() {
    this.router.navigate(['/home'], {fragment: 'orders'});
    document.querySelector('orders').scrollIntoView();
  }

  goToChannel() {
    this.router.navigate(['/home'], {fragment: 'channel'});
    document.querySelector('channel').scrollIntoView();
  }

  goToContact() {
    this.router.navigate(['/home'], {fragment: 'contact'});
    document.querySelector('contact').scrollIntoView();
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  logout() {
    this.authManagerService.logout();
    this.handleLoggedOut();
    window.location.reload();
  }

  handleLoggedOut() {
    this.showLogin.emit();
  }

  saveAndGoToHome(): void {
    this.newOrderStoreService.setCopyTrialLensRight(undefined);
    this.newOrderStoreService.setCopyTrialLensLeft(undefined);
    this.saveCartAndLeave();
  }

  private saveCartAndLeave() {
    let saveLenses: OrderItem[] = [];
    this.cartService.getCartItems().pipe(map(orderItems => orderItems.filter(orderItem => orderItem.isNew === true || orderItem.isUpdate === true))).subscribe(orderItems => saveLenses = orderItems);
    this.ordersApiService.updateCart({orderItems: saveLenses}).subscribe(response => {
      if(response.success) {
        this.messages.info("newOrder.messages.cartUpdated");
        this.cartService.markLensesAsSaved();
        this.router.navigate(['/']);
        this.cartService.fetchCartItems();
      } else {
        this.messages.error("newOrder.messages.cartUpdateFailed");
        this.router.navigate(['/']);
      }
    });
  }
}
